import type { SourceItem } from "@/services/aiService";

interface Props {
  sources: SourceItem[];
}

export default function ChatSourceCards({ sources }: Props) {
  const filtered = sources.filter((s) => {
    try {
      const host = new URL(s.url).hostname.replace("www.", "");
      return host === "my.evvy.com";
    } catch {
      return false;
    }
  });

  if (filtered.length === 0) return null;

  return (
    <div className="flex flex-col gap-[var(--chat-space-03)] w-full">
      {filtered.map((source) => (
        <a
          key={source.url}
          href={source.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col gap-[var(--chat-space-03)] border border-[var(--chat-grey-100)] rounded-[var(--chat-corner-base)] px-[var(--chat-space-06)] py-[var(--chat-space-05)] max-w-[var(--chat-max-bubble)] overflow-hidden hover:bg-[var(--chat-creme)] transition-colors"
        >
          <div className="flex items-center gap-[var(--chat-space-03)]">
            <img
              src={source.favicon_url}
              alt=""
              className="w-[var(--chat-icon-base)] h-[var(--chat-icon-base)] shrink-0"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = "none";
              }}
            />
            <span className="text-[14px] text-[var(--chat-grey-500)] leading-[1.5] truncate">
              {(() => {
                try {
                  return new URL(source.url).hostname.replace("www.", "");
                } catch {
                  return source.url;
                }
              })()}
            </span>
          </div>
          <p className="text-[var(--chat-text-base)] font-semibold leading-[1.5] text-[var(--chat-black)] truncate">
            {source.title}
          </p>
          {source.description && (
            <p className="text-[var(--chat-text-base)] leading-[1.5] text-[var(--chat-black)] line-clamp-2">
              {source.description}
            </p>
          )}
        </a>
      ))}
    </div>
  );
}
